import { Newsboard } from '../lib/graphql/api/graphql';
import hasExecutivePage from '../lib/hasExecutivePage';

const getExecutiveMenuSegment = (newsboard: Newsboard) => (
  hasExecutivePage(newsboard)
    ? [{
      id: 'executive',
      router: true,
      route: 'executive',
      items: [],
      executive: true,
    }] : []);

export default getExecutiveMenuSegment;
